import BaseService from './BaseService';
import { API_ENDPOINTS } from '../constants';

class MaterialService {
  async getMaterials(params = {}) {
    // This endpoint doesn't require authentication but accepts it for personalized data
    const url = `${process.env.REACT_APP_API_URL || 'http://localhost:3000/api'}${API_ENDPOINTS.MATERIALS.LIST}`;
    
    // Build query string
    const queryParams = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        queryParams.append(key, params[key]);
      }
    });
    
    const fullUrl = queryParams.toString() ? `${url}?${queryParams.toString()}` : url;
    
    console.log('MaterialService.getMaterials - Full URL:', fullUrl);
    console.log('MaterialService.getMaterials - Params:', params);
    
    try {
      // Get auth token if available
      const token = typeof window !== 'undefined' ? localStorage.getItem('accessToken') : null;
      
      const headers = {
        'Content-Type': 'application/json',
      };
      
      // Add Authorization header if token exists
      if (token) {
        headers['Authorization'] = `Bearer ${token}`;
      }
      
      const response = await fetch(fullUrl, {
        method: 'GET',
        headers: headers
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      return await response.json();
    } catch (error) {
      console.error('Fetch materials error:', error);
      throw error;
    }
  }

  async getMaterialById(id) {
    return BaseService.get(API_ENDPOINTS.MATERIALS.BY_ID(id));
  }

  async getCategories() {
    return BaseService.get(API_ENDPOINTS.MATERIALS.CATEGORIES, {}, { useCache: true });
  }

  async getParentCategories() {
    // This endpoint doesn't require authentication
    const url = `${process.env.REACT_APP_API_URL || 'http://localhost:3000/api'}${API_ENDPOINTS.MATERIALS.PARENT_CATEGORIES}`;
    
    try {
      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }
      });
      
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      return await response.json();
    } catch (error) {
      console.error('Fetch parent categories error:', error);
      throw error;
    }
  }

  async getPopularMaterials(params = {}) {
    return BaseService.get(API_ENDPOINTS.MATERIALS.POPULAR, params);
  }

  async searchMaterials(query, params = {}) {
    return BaseService.get(API_ENDPOINTS.MATERIALS.SEARCH, { q: query, ...params });
  }

  async incrementViewCount(id) {
    return BaseService.post(API_ENDPOINTS.MATERIALS.VIEW(id));
  }

  async likeMaterial(id) {
    return BaseService.post(API_ENDPOINTS.MATERIALS.LIKE(id));
  }

  async unlikeMaterial(id) {
    return BaseService.delete(API_ENDPOINTS.MATERIALS.UNLIKE(id));
  }

  async toggleLike(id) {
    return BaseService.post(API_ENDPOINTS.MATERIALS.TOGGLE_LIKE(id));
  }

  async createMaterial(data) {
    return BaseService.post(API_ENDPOINTS.MATERIALS.CREATE, data);
  }

  async updateMaterial(id, data) {
    return BaseService.put(API_ENDPOINTS.MATERIALS.UPDATE(id), data);
  }

  async deleteMaterial(id) {
    return BaseService.delete(API_ENDPOINTS.MATERIALS.DELETE(id));
  }

  async createCategory(data) {
    return BaseService.post(API_ENDPOINTS.MATERIALS.CREATE_CATEGORY, data);
  }

  async updateCategory(id, data) {
    return BaseService.put(API_ENDPOINTS.MATERIALS.UPDATE_CATEGORY(id), data);
  }

  async deleteCategory(id) {
    return BaseService.delete(API_ENDPOINTS.MATERIALS.DELETE_CATEGORY(id));
  }

  // Parent Category CRUD
  async createParentCategory(data) {
    return BaseService.post(API_ENDPOINTS.MATERIALS.PARENT_CATEGORIES, data);
  }

  async deleteParentCategory(id) {
    return BaseService.delete(`${API_ENDPOINTS.MATERIALS.PARENT_CATEGORIES}/${id}`);
  }

  // Category Ingredients CRUD
  async getCategoryIngredients(categoryId, params = {}) {
    return BaseService.get(API_ENDPOINTS.MATERIALS.CATEGORY_INGREDIENTS(categoryId), params);
  }

  async createCategoryIngredient(categoryId, data) {
    return BaseService.post(API_ENDPOINTS.MATERIALS.CATEGORY_INGREDIENTS(categoryId), data);
  }

  async updateCategoryIngredient(categoryId, ingredientId, data) {
    return BaseService.put(API_ENDPOINTS.MATERIALS.CATEGORY_INGREDIENT(categoryId, ingredientId), data);
  }

  async deleteCategoryIngredient(categoryId, ingredientId) {
    return BaseService.delete(API_ENDPOINTS.MATERIALS.CATEGORY_INGREDIENT(categoryId, ingredientId));
  }

  // Global Ingredient Names CRUD
  async getIngredientNames(params = {}) {
    return BaseService.get(API_ENDPOINTS.MATERIALS.INGREDIENT_NAMES, params);
  }

  async getIngredientNameById(id) {
    return BaseService.get(API_ENDPOINTS.MATERIALS.INGREDIENT_NAME_BY_ID(id));
  }

  async createIngredientName(data) {
    return BaseService.post(API_ENDPOINTS.MATERIALS.INGREDIENT_NAMES, data);
  }

  async updateIngredientName(id, data) {
    return BaseService.put(API_ENDPOINTS.MATERIALS.INGREDIENT_NAME_BY_ID(id), data);
  }

  async deleteIngredientName(id) {
    return BaseService.delete(API_ENDPOINTS.MATERIALS.INGREDIENT_NAME_BY_ID(id));
  }
}

export default new MaterialService();
